import { useEffect, useState } from "react";

const FINE_POINTER_QUERY = "(hover: hover) and (pointer: fine)";

export function useFinePointer(): boolean {
  const [hasFinePointer, setHasFinePointer] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(FINE_POINTER_QUERY).matches;
  });

  useEffect(() => {
    const mediaQueryList = window.matchMedia(FINE_POINTER_QUERY);

    const handleChange = (event: MediaQueryListEvent) => setHasFinePointer(event.matches);

    mediaQueryList.addEventListener("change", handleChange);
    return () => mediaQueryList.removeEventListener("change", handleChange);
  }, []);

  return hasFinePointer;
}
